"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paper = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = tslib_1.__importStar(require("styled-components"));
const theme_1 = require("./theme");
/**
 * Basic surface with radius and shadow defined by design system.
 * It should be used to create menu/popover surfaces and much more.
 */
exports.Paper = styled_components_1.default.div.attrs((props) => {
    var _a;
    return ({
        'data-test': (_a = props['data-test']) !== null && _a !== void 0 ? _a : 'paper',
        'data-test-specifier': props['data-test-specifier'],
    });
}) `
  background-color: ${theme_1.paperTheme.background};
  box-shadow: ${(0, theme_1.depthVariant)((variant) => variant.shadow)};
  border-radius: ${(0, theme_1.radiusVariant)((variant) => variant.radius)};
  ${({ isPadded }) => isPadded &&
    (0, styled_components_1.css) `
      padding: ${(0, theme_1.radiusVariant)((variant) => variant.padding)};
    `}
`;
//# sourceMappingURL=Paper.js.map